/**
 * The JSON:API `errors` of a failed request, or `[]` when it has none — a
 * plain-text body (a 403), a network error, or an `AuthError` without a
 * response. Reads a copy, leaving the body for anyone else.
 */
export const readJsonApiErrors = async (error) => {
  try {
    const body = await error.response.clone().json();
    return Array.isArray(body?.errors) ? body.errors : [];
  } catch {
    return [];
  }
};

/**
 * Groups error details by the attribute their `source.pointer` names, relative
 * to `/data/attributes`: `/data/attributes/redirectUris/0` → `redirectUris/0`.
 * An error about the whole resource (`/data/attributes`, `/data`, or no
 * pointer) is grouped under `''`.
 */
export const jsonApiErrorsByField = (errors = []) =>
  errors.reduce((byField, { detail, title, source }) => {
    const field = (source?.pointer || '').replace(
      /^\/data(\/attributes)?\/?/,
      ''
    );
    return {
      ...byField,
      [field]: [...(byField[field] || []), detail || title],
    };
  }, {});
